import React from 'react';
import {EventStore, ScrollData} from './store';

interface Props {
  onScroll: (e: ScrollData) => void;
  children?: React.ReactNode;
}

export default class ScrollConsumer extends React.PureComponent<Props> {
  componentDidMount(): void {
    const {onScroll} = this.props;
    EventStore.subscribe(onScroll);
  }

  componentDidUpdate(prevProps: Props): void {
    const {onScroll: prevOnScroll} = prevProps;
    const {onScroll} = this.props;
    if (onScroll !== prevOnScroll) {
      EventStore.unsubscribe(prevOnScroll);
      EventStore.subscribe(onScroll);
    }
  }

  componentWillUnmount(): void {
    const {onScroll} = this.props;
    EventStore.unsubscribe(onScroll);
  }

  render(): React.ReactNode {
    const {children} = this.props;
    return children;
  }
}
